import React from 'react';
import { CtaButton } from './CtaButton';
const deliverables = ['Masterclasses grabadas', '+8 hs de reproducción', 'Material descargable pdf', 'Workbooks de trabajo', 'Comunidad UGC', 'Feedback de Brenda', 'Guía y acompañamiento', 'Plantillas Portafolio UGC', 'Oportunidades Collabs', 'Tutoriales, Bonus y más!'];
const syllabus = ['1- Conceptos base del UGC', '2- Marketing UGC', '3- Storytelling UGC', '4- Estructura videos UGC', '5- Grabación + Edición UGC', '6- Armado de Portfolio UGC', '7- Tarifas y Packs UGC', '8- Outreach con las marcas', '9- Primeras Colaboraciones', '10-Maximiza tus ganancias', '11- Plataformas para crecer'];
export function ProgramDetails() {
  return <section className="px-6 py-12 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-184">
      <h2 className="font-serif text-4xl md:text-5xl text-brand-navy mb-8" data-id="element-185">
        ¿Qué vas a recibir?
      </h2>

      <p className="font-bold underline text-brand-navy text-xl mb-8" data-id="element-186">
        ACCESO INMEDIATO A 👇🏻
      </p>

      <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16 text-left max-w-5xl mx-auto" data-id="element-187">
        {deliverables.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-188">
            <span className="text-xl shrink-0" data-id="element-189">✔</span>
            <span className="font-serif italic text-brand-navy text-xl" data-id="element-190">
              {item}
            </span>
          </li>)}
      </ul>

      <h3 className="font-serif text-4xl md:text-5xl text-brand-navy mb-6 leading-tight" data-id="element-191">
        Temario del <br data-id="element-192" /> Programa:
      </h3>

      {/* Laptop image */}
      <img src="https://cdn.magicpatterns.com/uploads/17BXGsDi2bPr4y23Nvkykv/pasted-image.png" alt="Temario del programa en laptop" className="w-full max-w-4xl h-auto mb-8 drop-shadow-xl" data-id="element-193" />

      {/* Syllabus white box */}
      <div className="w-full max-w-4xl bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-brand-navy/10 text-left mb-10" data-id="element-194">
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-195">
          {syllabus.map((item, i) => <li key={i} className="font-serif text-brand-navy text-xl" data-id="element-196">
              {item}
            </li>)}
        </ul>
      </div>

      <p className="font-serif text-2xl text-brand-navy mb-6" data-id="element-197">
        Así se ve por dentro 👇🏻
      </p>

      {/* Vimeo Video */}
      <div className="w-full max-w-2xl rounded-3xl overflow-hidden shadow-2xl bg-black aspect-[3/4] relative" data-id="element-198">
        <iframe src="https://player.vimeo.com/video/1162402905?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="Programa Formula UGC" data-id="element-199"></iframe>
      </div>

      <div className="md:scale-125 md:my-12" data-id="element-200">
        <CtaButton variant="gold" className="mt-10" data-id="element-201">
          ¡SI, QUIERO INSCRIBIRME!
        </CtaButton>
      </div>
    </section>;
}